import { useDispatch } from "react-redux";
import { ACTIONS } from "src/_config";

export function useAppEventAction() {
  const dispatch = useDispatch();

  const pushGameStatusChangeSocketDataIntoGameList = (socketData: Record<string, unknown>, _userId?: number) => {
    const params = {
      socketData: socketData,
      // userId: userId,
    };
    dispatch({
      type: ACTIONS.EVENT.GET_SOCKET_START_DATA_AND_PUSH_TO_GAME_LIST,
      payload: params,
    });
  };

  const pushGameStatusChangeSocketDataIntoGameDetails = (socketData: Record<string, unknown>, userId: number) => {
    const params = {
      socketData: socketData,
      userId: userId,
    };
    dispatch({
      type: ACTIONS.EVENT.GET_SOCKET_START_DATA_AND_PUSH_TO_GAME_DETAILS,
      payload: params,
    });
  };

  const pushGameStatusMessageSocketDataIntoStatusList = (socketData: Record<string, unknown>, userId: number) => {
    const params = {
      socketData: socketData,
      userId: userId,
    };
    dispatch({
      type: ACTIONS.EVENT.GET_SOCKET_STATUS_MESSAGE_AND_PUSH_TO_STATUS_LIST,
      payload: params,
    });
  };

  const pushRiderWithVoteDetailsSocketDataIntoRiderList = (socketData: Record<string, unknown>) => {
    const params = {
      socketData: socketData,
    };
    dispatch({
      type: ACTIONS.EVENT.GET_SOCKET_RIDER_WITH_VOTE_DETAILS,
      payload: params,
    });
  };

  const pushWiningTruckDetailsSocketDataIntoWiningDetails = (socketData: Record<string, unknown>, userId: number) => {
    const params = {
      socketData: socketData,
      userId: userId,
    };
    dispatch({
      type: ACTIONS.EVENT.GET_WINING_SOCKET_DATA_AND_PUSH_TO_WINING_DETAILS,
      payload: params,
    });
  };

  const showWiningTruckDetailsModal = (isOpen: boolean) => {
    dispatch({
      type: ACTIONS.EVENT.OPEN_WINING_MODAL,
      payload: isOpen,
    });
  };

  const emptyGameDetails = () => {
    dispatch({
      type: ACTIONS.EVENT.GET_EVENT_GAME_DETAILS,
      payload: null,
    });
  };

  const fromRouteHandler = (formRoute: Record<string, unknown>) => {
    dispatch({
      type: ACTIONS.EVENT.NEXT_EVENT_FROM_ROUTE,
      payload: formRoute,
    });
  };

  const updateEventGlowingStatus = (socketData: Record<string, unknown>) => {
    const params = { socketData };
    dispatch({
      type: ACTIONS.EVENT.GET_EVENT_LIST_GLOWING_SOCKET,
      payload: params,
    });
  };

  const updateLoginRequired = (loginR: number) => {
    dispatch({
      type: ACTIONS.EVENT.RODEO_EVENT_LOGIN_REQUIRED,
      payload: loginR,
    });
  };

  const resetPickIds = () => {
    dispatch({
      type: ACTIONS.EVENT.RESET_PICK_ID,
    });
  };

  const rodeoEventSettings = (data: Record<string, unknown>) => {
    dispatch({
      type: ACTIONS.EVENT.RODEO_EVENT_SETTINGS,
      payload: data,
    });
  };

  const setSiteHeader = (data: boolean) => {
    dispatch({
      type: ACTIONS.EVENT.SITE_HEADER,
      payload: data,
    });
  };

  const setStatusMsg = (data: unknown) => {
    dispatch({
      type: ACTIONS.EVENT.GET_STATUS_MESSAGE,
      payload: data,
    });
  };

  const getIrStatusMessage = (data: Record<string, unknown>) => {
    dispatch({
      type: ACTIONS.EVENT.GET_IR_STATUS_MESSAGE,
      payload: data,
    });
  };

  const updateTaskListScanCount = (data: Record<string, unknown>) => {
    dispatch({
      type: ACTIONS.EVENT.UPDATE_TASK_LIST_SCAN_COUNT,
      payload: data,
    });
  };

  const updateTaskListScanStart = (data: Record<string, unknown>) => {
    dispatch({
      type: ACTIONS.EVENT.UPDATE_TASK_LIST_SCAN_START,
      payload: data,
    });
  };

  return {
    pushGameStatusChangeSocketDataIntoGameList,
    pushGameStatusChangeSocketDataIntoGameDetails,
    pushGameStatusMessageSocketDataIntoStatusList,
    pushRiderWithVoteDetailsSocketDataIntoRiderList,
    pushWiningTruckDetailsSocketDataIntoWiningDetails,
    fromRouteHandler,
    emptyGameDetails,
    updateEventGlowingStatus,
    showWiningTruckDetailsModal,
    updateLoginRequired,
    resetPickIds,
    rodeoEventSettings,
    setSiteHeader,
    setStatusMsg,
    getIrStatusMessage,
    updateTaskListScanCount,
    updateTaskListScanStart,
  };
}
